import { InjectionToken, Signal } from "@angular/core";
import { FetchState } from "@at/shared";
import { ContactsResponse } from "../../api";

export const USER_CONTACTS_STATE = new InjectionToken<Signal<FetchState<ContactsResponse>>>(
  'USER_CONTACTS_STATE',
);
